import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router";

import { EnvironmentTopStrip } from "@/components/EnvironmentCard";
import BgAuth from "@/images/bg-auth.png";

export const AuthLayout = () => {
  return (
    <>
      <EnvironmentTopStrip />
      <Box
        as="main"
        minW="100vw"
        minH="100vh"
        w={{ base: "100vw", sm: "full" }}
        h={{ base: "100vh", sm: "full" }}
        bgRepeat="no-repeat"
        bgPos="center"
        bgSize="cover"
        bgImage={BgAuth}
        p={{ base: "0", sm: "50px", md: "100px" }}>
        <Flex h="full" w="full">
          <Outlet />
        </Flex>
      </Box>
    </>
  );
};
